import { Injectable } from "@angular/core";
import { AngularFireRemoteConfig } from "@angular/fire/compat/remote-config";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class RemoteConfigForpsService {
  isCreateHide$ = new BehaviorSubject(false);

  constructor(private remoteConfig: AngularFireRemoteConfig) {
    this.remoteConfig.getBoolean("hide_create_ps").then((d) => {
      this.isCreateHide$.next(d);
    }).catch((error) => {
      return error;
    });
  }
}
